<template>
  <ErrorPageLayout
    pageTitle="Oops, this page no longer exists!"
    pageDescription="It seems that the page you’re trying to reach is no longer available."
    mainImage="no-page"
  ></ErrorPageLayout>
</template>

<script setup>
import { onMounted, defineAsyncComponent } from 'vue';

const ErrorPageLayout = defineAsyncComponent(() => import('@/layouts/ErrorPageLayout.vue'));

onMounted(() => {
  const appEl = document.querySelector('#app');

  appEl.classList.remove('olympus-app');
});
</script>

<style scoped>
#NotFound {
  height: 100vh;
  display: grid;
  place-items: center;
}
</style>
